import { render, staticRenderFns } from "./vehicleRegistration.vue?vue&type=template&id=7766641a&scoped=true"
import script from "./vehicleRegistration.vue?vue&type=script&lang=js"
export * from "./vehicleRegistration.vue?vue&type=script&lang=js"
import style0 from "./vehicleRegistration.vue?vue&type=style&index=0&id=7766641a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7766641a",
  null
  
)

export default component.exports